import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  NavPill,
  NavPillList,
  NavPillListItem,
} from '@spotify-internal/encore-creator-web';
import { screenSmMin } from '@spotify-internal/encore-foundation';
import Overview from './Overview';
import TopSongs from './TopSongs';
import TopPlaylists from './TopPlaylists';

const Siderail = styled.div`
  grid-area: stats;
  min-width: 0;

  @media (min-width: ${screenSmMin}) {
    grid-row-start: 3;
  }
`;

const StatSection = React.memo(props => {
  const { isMobile, activeStatsTabIndex, onChangeStatsTab } = props;

  const OverviewSection = <Overview {...props} />;

  const SongSection = <TopSongs {...props} />;

  const PlaylistSection = <TopPlaylists {...props} />;

  const NavPills = [
    {
      id: 'overview',
      label: 'Overview',
      content: OverviewSection,
    },
    {
      id: 'songs',
      label: 'Songs',
      content: SongSection,
    },
    {
      id: 'playlists',
      label: 'Playlists',
      content: PlaylistSection,
    },
  ];

  return (
    <React.Fragment>
      {isMobile ? (
        <Siderail>
          <NavPill
            list={
              <NavPillList style={{ textAlign: 'left' }}>
                {NavPills.map((tab, index) => (
                  <NavPillListItem
                    key={tab.id}
                    id={tab.id}
                    active={index === activeStatsTabIndex}
                    label={tab.label}
                    onClick={e => onChangeStatsTab(e, index)}
                  />
                ))}
              </NavPillList>
            }
          >
            <div
              role="tabpanel"
              aria-labelledby={NavPills[activeStatsTabIndex].id}
            >
              {NavPills[activeStatsTabIndex].content}
            </div>
          </NavPill>
        </Siderail>
      ) : (
        <Siderail>
          {OverviewSection}
          {SongSection}
          {PlaylistSection}
        </Siderail>
      )}
    </React.Fragment>
  );
});

StatSection.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  activeStatsTabIndex: PropTypes.number.isRequired,
  onChangeStatsTab: PropTypes.func.isRequired,
};

/* eslint-disable-next-line import/no-default-export */
export default StatSection;
